import React, { FC, ReactElement } from 'react'
import { WelcomeContainer } from '../WelcomeContainer/WelcomeContainer'
import { DocumentViewer } from '../DocumentViewer/DocumentViewer'
import { Tags } from '../../../../React/Common/API/Contentful/Constants'

export const PrivacyPolicy: FC = (): ReactElement => (
    <WelcomeContainer>
        <DocumentViewer tag={Tags.PRIVACY_POLICY} />
    </WelcomeContainer>
)
